import { useState } from "react";
import { List, ListItem, ListItemText, Collapse, Box } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { formatAddress } from "../../../../helpers/helper";
import "./styles.css";

function SimpleTreeView({ data, handleClickOnListItem }) {
  const [open, setOpen] = useState({});

  const handleClick = (itemId) => {
    setOpen((prev) => ({ ...prev, [itemId]: !prev[itemId] }));
  };

  const renderTreeItemContent = (node) => (
    <Box className="tree-item__content" onClick={() => handleClickOnListItem(node.id)}>
      <Box>{node.name}</Box>
      {node.addressDto && <Box sx={{ color: "var(--headers)" }}>{formatAddress(node.addressDto)}</Box>}
    </Box>
  );

  const renderTree = (nodes) => (
    <List component="div" disablePadding className="tree__list">
      {nodes.map((node) => {
        const hasChildren = node.children && node.children.length > 0;
        const isOpen = open[node.id];
        const displayLevel = node.level;

        return (
          <Box key={node.id}>
            <ListItem
              onClick={() => hasChildren && handleClick(node.id)}
              className="tree-item"
              sx={{
                ml: `${displayLevel && hasChildren === 0 ? 26 : displayLevel * 26}px !important`,
                p: "14px",
                borderLeft: displayLevel === 0 ? "none" : "1px solid #e0e0e0",
              }}
            >
              {hasChildren ? isOpen ? <ExpandLess /> : <ExpandMore /> : <></>}
              {!hasChildren && displayLevel !== 0 && <Box sx={{ width: "2px" }}></Box>}
              <ListItemText primary={renderTreeItemContent(node)} sx={{ m: 0 }} />
            </ListItem>

            {hasChildren && (
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                {renderTree(node.children)}
              </Collapse>
            )}
          </Box>
        );
      })}
    </List>
  );

  return (
    <Box
      sx={{
        minHeight: 400,
        width: "60%",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {renderTree(data)}
    </Box>
  );
}

export default SimpleTreeView;
